require('./legalInterstitial.scss');

const PropTypes = require('prop-types');
const React = require('react');
const {
    Component
} = require('react');

// @components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @helpers
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const downIcon = require('assets/icons/icon-down.svg');

class LIType00 extends Component {
    constructor(props) {
        super(props)
        this.handleSmooth = this.handleSmooth.bind(this);
        this.handleScroll=this.handleScroll.bind(this)
        this.state = {
            showButton: false,   
        }
    }
    
    componentDidMount(){
        const { scrollDown, handleCheck ,modifier} = this.props;
        if(!__CONTACT_CENTER__){   

            const element = document.getElementById('scrollConentParent')
            if(element && modifier!=="fioc"){
            var hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
            scrollDown && hasVerticalScrollbar &&  this.setState({showButton:true});
            (scrollDown && hasVerticalScrollbar) ? handleCheck(false): handleCheck(true);
            scrollDown && element.addEventListener('smooth', this.handleSmooth,true);
            scrollDown && element.addEventListener('scroll', this.handleScroll,true);
  
        }
        }    
            
    }

    componentWillUnmount(){
        const element = document.getElementById('scrollConentParent');
        element && element.removeEventListener('smooth', this.handleSmooth,true);
        element && element.removeEventListener('scroll', this.handleScroll,true);

    }
    
    handleSmooth(e) {
            e.preventDefault();
            const { handleCheck } = this.props;
            const scrollEndDiv = document.getElementById('endContent');
            const element = document.getElementById('scrollConentParent')
            const scrollBtn = document.getElementById("scrollDownIcon");
            scrollEndDiv.scrollIntoView({behavior:'smooth'});
            if(scrollBtn !==null) {
            if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 150) {  
                scrollBtn.style.opacity = 0.6;
            }
            setTimeout(function(){
                this.setState({showButton:false});    
            }.bind(this),500)
            handleCheck(true)
           element && element.removeEventListener('scroll', this.handleScroll,true);
      
           
        }
    }
    handleScroll(e) {
        e.preventDefault();
        const { handleCheck } = this.props;
        const element = document.getElementById('scrollConentParent')
        const scrollBtn = document.getElementById("scrollDownIcon");

        if(scrollBtn !==null) {
        if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 150) {  
            scrollBtn.style.opacity = 0.6;
        }
    
            setTimeout(function(){
                this.setState({showButton:false});    
            }.bind(this),500)
            handleCheck(true)
           element && element.removeEventListener('scroll', this.handleScroll,true);
        
    }
}

    render() {
        const {
            body,
            checkboxText,
            confirmed,
            handleCheck,
            modifier,
            scrollDown
        } = this.props;
        const cssModifier = modifier !== '' ? " legal-interstitial--" + modifier : '';
        const cssClasses = 'legal-interstitial' + cssModifier;
        const legalInterstitialClassName = contactCenterClassName('legal-interstitial__body--cc', 'legal-interstitial__body');
        let checkbox;

        if (!!checkboxText) {
            checkbox = (
                <OKCheckbox
                    idName={'id'}
                    label={<HTMLSafeInjector message={checkboxText} />}
                    onChange={handleCheck}
                    value={confirmed}
                />
            );
        }
        return scrollDown ? (
            
            <div className={`${cssClasses} scroll-conent-parent`} id="scrollConentParent" onScroll={this.handleScroll}>
                {this.state.showButton &&
                    <img className="scroll-down-icon" src={downIcon} id="scrollDownIcon" onClick={this.handleSmooth}/>
                   }
                <div className={legalInterstitialClassName} id="scrollContent" >
                    {body}
                    <div id="endContent"
                    ></div>
                </div>
            </div>
        ):(
            <div className={cssClasses} style={{'overflow':'auto'}}>
                <div className={legalInterstitialClassName}>
                    {body}
                </div>
                {checkbox}
            </div>
        );
    }
}

LIType00.propTypes = {
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    checkboxText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    confirmed: PropTypes.bool,
    handleCheck: PropTypes.func.isRequired,
    modifier: PropTypes.oneOf(['fioc']),
    scrollDown: PropTypes.bool,
};

LIType00.defaultProps = {
    modifier: ''
};

module.exports.LIType00 = LIType00;

